import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const PercentRecField: FC<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;

  const value = useMemo(() => dataItem?.[field], [dataItem, field]);

  const displayValue = value === 'N/A' ? value : `${value}%`;

  return (
    <GridCellBase {...props} title={displayValue}>
      {displayValue}
    </GridCellBase>
  );
};

export default PercentRecField;
